export default __webpack_public_path__ + "static/media/char.23917733.png";